module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 174.2 174.2\" xml:space=\"preserve\"><path d=\"M164 137.9c-25.4-15.7-24-66.6-24-67.4 0-23.8-15.8-43.9-37.5-50.6v-4.6C102.5 6.9 95.6 0 87.1 0S71.7 6.9 71.7 15.4v4.6C50.1 26.6 34.3 46.8 34.3 70.8c0.5 14.2-2.9 54.1-24 67.1 -2.8 1.8-4.2 5.2-3.3 8.4 0.9 3.2 3.8 5.4 7.2 5.4h44.7c3 12.9 14.5 22.5 28.2 22.5s25.3-9.6 28.2-22.5h44.7c3.3 0 6.3-2.2 7.2-5.4C168.2 143.1 166.8 139.7 164 137.9zM80.4 136.8H32.5c17.8-25.2 16.7-64.5 16.7-66.3 0-20.9 17-37.9 37.9-37.9 20.9 0 37.9 17 37.9 37.7 -0.1 2-1.2 41.4 16.7 66.5H80.4z\"></path></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/EmailSignUp/images/bell.svg
 ** module id = 1354
 ** module chunks = 1
 **/